"use strict";
/*
 * Created on 06.04.2021
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var PromotionPerformanceRowSupplierInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionPerformanceRowSupplierInfoConverter, _DataObjectConverter_);

  function PromotionPerformanceRowSupplierInfoConverter() {
    _classCallCheck(this, PromotionPerformanceRowSupplierInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceRowSupplierInfoConverter).apply(this, arguments));
  }

  return PromotionPerformanceRowSupplierInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionPerformanceRowSupplierInfoConverter = PromotionPerformanceRowSupplierInfoConverter;